import React from 'react';

import { Title } from 'components/Misc/Typography';
import { Button } from 'components/Misc/Form';

const Grade = ({ grade }) => {
	return (
		<div className="py-3 px-4 flex items-center">
			<Title
				title={grade.title}
				className="ml-3 flex-1"
			/>

			<Button
				small
				square
				icon="link"
				to={`/grades/${grade.id}`}
				className="ml-2"
			/>
		</div>
	);
};

export default Grade;